import React, {useState} from 'react';
import './index.scss';
import ColumnTitleWithIcon from "../ColumnTitleWithIcon/index.js";
import IconButton from "../IconButton/index.js";

const SectionItemKeywords = ({column, item, value, error, onPropChange, withTitle = true, type}) => {
    const [inputValue, setInputValue] = useState("");

    const handleOnAdd = () => {
        if(!inputValue.length) {
            return;
        }
        onPropChange({ [column.accessor]: value.concat(inputValue) });
        setInputValue("")
    }

    const handleOnDelete = valueDelete => {
        onPropChange({ [column.accessor]: value.filter(v => v !== valueDelete) });
    }

    return (
        <div className={'sectionKeyWords'}>
            <div className={'sectionItemText'}>
                {withTitle && <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />}
                <div className={'inputItem'}>
                    <input type="text" value={inputValue} onChange={({target}) => setInputValue(target.value)}/>
                    <IconButton isIcon iconName={'addNew'} onClick={handleOnAdd}/>
                </div>
            </div>
            <div className={'sectionKeyWordsCrumbs'}>
                {value.map(v => (<div key={v} className={'item'} onClick={() => handleOnDelete(v)}>
                    <span>{v}</span>
                    <IconButton isIcon iconName={'delete'}/>
                </div>))}
            </div>
        </div>
    )
}

export default SectionItemKeywords;